import RawScoresSection from "./RawScoresSection";

export default RawScoresSection;
